import forEach from 'lodash/forEach'
import filter from 'lodash/filter'
import merge from 'lodash/merge'

export default function formatData({
  data: {
    pages,
    server,
    landing,
    fbPixel,
    config,
    scanData,
    scanPoints,
    dropdown,
    extraData,
  },
  localeItems,
  locale,
}) {
  let fields = []
  forEach(
    filter(
      pages,
      ({ type }) => type === 'Form' || type === 'FormSimple',
    ),
    ({ form }) => {
      fields = merge(fields, form)
    },
  )

  let questions = []
  forEach(
    filter(pages, ({ type }) => type === 'Quiz'),
    ({ quest }) => {
      questions = quest
    },
  )

  // const { questions } = pages.filter(page => {
  //   return page.type === 'Quiz'
  // })[0]

  const percent = 100 / (questions.length + 1)

  return {
    steps: {
      pages,
    },
    form: {
      fields,
      server,
      fbPixel,
      config,
    },
    landing: {
      landing,
    },
    quiz: {
      questions,
      percent,
      server,
    },
    locale: {
      locale,
      items: localeItems,
    },
    scanData,
    scanPoints,
    dropdown,
    extraData,
  }
}
